import { render } from "./DynamicThankYouPage.vue?vue&type=template&id=6cbc9cda&scoped=true"
import script from "./DynamicThankYouPage.vue?vue&type=script&lang=js"
export * from "./DynamicThankYouPage.vue?vue&type=script&lang=js"

import "./DynamicThankYouPage.vue?vue&type=style&index=0&id=6cbc9cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbc9cda"]])

export default __exports__